import url from "url/index";
import { SEO } from "utils/helmet/components/SEO";
import BonusListContainer from "containers/organisms/BonusListContainer";
import { useNavigate } from "react-router-dom";
import PageTitle from "components/atoms/PageTitle";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import PromocodeField from "../../../molecules/PromocodeField";

import "./styles.sass";

const BonusPage = () => {
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoint();

  const handleBack = () => {
    navigate({
      ...(!isDesktop && {
        pathname: url.routes.profile.index(),
      }),
    });
  };

  return (
    <>
      <SEO
        pathname={`/${url.config.profile.root}/${url.config.profile.bonus}`}
      />
      <div className="BonusPage">
        <div className="BonusPage__header">
          <PageTitle
            title="menu.left.mybonus"
            {...(!isDesktop ? { onBack: handleBack } : {})}
          />
          <PromocodeField />
        </div>
        <BonusListContainer />
      </div>
    </>
  );
};

export default BonusPage;
